import { render, staticRenderFns } from "./fireExtionguishingDetails.vue?vue&type=template&id=5919c19c&scoped=true&"
import script from "./fireExtionguishingDetails.vue?vue&type=script&lang=js&"
export * from "./fireExtionguishingDetails.vue?vue&type=script&lang=js&"
import style0 from "./fireExtionguishingDetails.vue?vue&type=style&index=0&id=5919c19c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5919c19c",
  null
  
)

export default component.exports